export default __webpack_public_path__ + "d7dd790f19daed902f716ecca5be2ec9.png";